import { PropsWithChildren } from "react";
import { Text, BoxProps } from "@chakra-ui/react";

type CaptionProps = {
  bold?: boolean;
  danger?: boolean;
};

function Caption({ bold, danger, ...props }: PropsWithChildren<CaptionProps & BoxProps>) {
  return (
    <Text
      color={danger ? "danger.700" : "primary"}
      fontSize="sm"
      fontWeight={bold ? "medium" : "regular"}
      sx={{
        "& a,a:visited": {
          color: "primary.500",
          textDecoration: "none",
        },
      }}
      {...props}
    />
  );
}

export default Caption;
